import { all, put, select, takeEvery } from 'redux-saga/effects'
import { filterTableRemoveData } from 'gnos-tables'
import _ from 'lodash'

import config from '../../../../../../../../../config'

import IntlSaga from '../../../../../../../../../services/translations/intl-saga'

import { LOCALE_PREFIX as LOCALE_DISTRIBUTION_PREFIX } from './components/DistributionTab/constants'
import { BLOCK_DATA_LOADED } from '../../../../../../../components/Workspace/components/HocBlock/constants'
import { SET_LOCALE } from '../../../../../../../../../services/translations/constants'

import {
    blockDataTransformed,
    blockSaveCustomData,
} from '../../../../../../../components/Workspace/components/HocBlock/actions'
import { removeData as tabsRemoveData } from '../../../../../../../../../components/Tabs/actions'

import { localeSelector, getAllRealEstatesIds, getTabsIds, getFilterTableIds } from './selectors'

import distributionTabSaga from './components/DistributionTab/saga'
import ownershipTabSaga from './components/OwnershipTab/saga'

const createChartData = (rows = [], locale, restriction) =>
    _.reduce(
        rows,
        (acc, row) => {
            const value = restriction ? row.restrictions || 0 : row.total || 0
            const restrictionPercent = (row.total || 0) > 0 ? (100 / row.total) * (row.restrictions || 0) : 0

            const area = {
                id: row.id,
                regionName: row.regionName,
                value,
                label:
                    '<div>' +
                    `<span style="color: ${(row.restrictions || 0) > 0 ? '#ed1c24' : '#000000'};">${
                        row.restrictions || 0
                    }</span>` +
                    `<span>/${row.total || 0}</span>` +
                    '</div>',
                balloonText:
                    '<div class="heat-map-tooltip">' +
                    `<div class="title margin">${row.regionName}</div>` +
                    '<div class="margin">' +
                    `<span>${IntlSaga.formatMessage(
                        locale,
                        `${LOCALE_DISTRIBUTION_PREFIX}.chart.tooltip.total`
                    )}</span>` +
                    `<span class="value">${row.total || 0}</span>` +
                    '</div>' +
                    '<div>' +
                    `<span>${IntlSaga.formatMessage(
                        locale,
                        `${LOCALE_DISTRIBUTION_PREFIX}.chart.tooltip.parcels`
                    )}</span>` +
                    `<span class="value">${row.parcels || 0}</span>` +
                    '</div>' +
                    '<div>' +
                    `<span>${IntlSaga.formatMessage(
                        locale,
                        `${LOCALE_DISTRIBUTION_PREFIX}.chart.tooltip.buildings`
                    )}</span>` +
                    `<span class="value">${row.buildings || 0}</span>` +
                    '</div>' +
                    '<div class="margin">' +
                    `<span>${IntlSaga.formatMessage(
                        locale,
                        `${LOCALE_DISTRIBUTION_PREFIX}.chart.tooltip.units`
                    )}</span>` +
                    `<span class="value">${row.units || 0}</span>` +
                    '</div>' +
                    '<div>' +
                    `<span>${IntlSaga.formatMessage(
                        locale,
                        `${LOCALE_DISTRIBUTION_PREFIX}.chart.tooltip.restrictions`
                    )}</span>` +
                    `<span class="value">${row.restrictions || 0} (${_.round(restrictionPercent)}%)</span>` +
                    '</div>' +
                    '</div>',
            }

            return {
                data: [...acc.data, area],
                zeroValues: acc.zeroValues && value === 0,
            }
        },
        { data: [], zeroValues: true }
    )

const MODULE_KEY = config.modules.report.key
const BLOCK_KEY = config.modules.report.blocks.estates.key

function* onDataLoaded(_action) {
    const blockKey = _.get(_action, 'data.blockKey', null)
    if (blockKey !== config.modules.report.blocks.estates.key) return null

    const module = _.get(_action, 'data.module', null)
    const id = _.get(_action, 'data.id', null)
    if (!module || !id || !blockKey) return null

    const locale = yield select(localeSelector)
    const data = _.get(_action, 'data.data', null)

    // Transformation start
    const rows = _.get(data, 'rows', [])
    const transformedData = {
        chart: {
            restriction: createChartData(rows, locale, true),
            total: createChartData(rows, locale, false),
        },
        summary: data.summary,
    }
    // Transformation end

    yield put(blockDataTransformed(module, id, blockKey, transformedData))

    return null
}

function* onLocaleChange() {
    // clear block customData for extended tab
    const realEstatesIds = yield select(getAllRealEstatesIds)
    const clearCustomDataActions = realEstatesIds
        .map((realEstatesId) =>
            put(
                blockSaveCustomData(MODULE_KEY, realEstatesId, BLOCK_KEY, {
                    ownershipList: {},
                    ownershipListDetail: {},
                    ownershipListEstateDetail: {},
                    ownershipListEstateDetailRow: {},
                })
            )
        )
        .toJS()

    // remove data of of tabs component of realEstates module of estates block
    const tabsIds = yield select(getTabsIds)
    const removeDataTabsActions = tabsIds.map((tabsId) => put(tabsRemoveData(tabsId))).toJS()

    // remove data of filter tables of realEstates module of estates block
    const filterTableIds = yield select(getFilterTableIds)
    const removeDataFilterTableActions = filterTableIds.map((tableId) => put(filterTableRemoveData(tableId))).toJS()

    // dispatch all actions
    yield all([...clearCustomDataActions, ...removeDataTabsActions, ...removeDataFilterTableActions])

    return null
}

export default function* blockTransformSaga() {
    yield all([
        takeEvery(BLOCK_DATA_LOADED, onDataLoaded),
        takeEvery(SET_LOCALE, onLocaleChange),
        distributionTabSaga(),
        ownershipTabSaga(),
    ])
}
